const APP_LOADER_SELECTOR = "#app-loader";

export function showAppLoader(): void {
  const appLoaderElement = <HTMLDivElement | undefined>(
    document.querySelector(APP_LOADER_SELECTOR)
  );

  if (appLoaderElement) {
    appLoaderElement.style.visibility = "visible";
  }
}

export function hideAppLoader(): void {
  const appLoaderElement = <HTMLDivElement | undefined>(
    document.querySelector(APP_LOADER_SELECTOR)
  );

  if (appLoaderElement) {
    appLoaderElement.style.display = "none";
  }
}
